import { SvgIcon } from "@mui/material";
import React from "react";

export default function InboxIcon({ fill, ...props }: any) {
  return (
    <SvgIcon
      width="148"
      height="50"
      viewBox="0 0 148 50"
      fill={fill}
      stroke={fill}
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="25"
        viewBox="0 0 24 25"
        fill="none"
      >
        <path
          d="M21 15.5723C21 16.1027 20.7893 16.6114 20.4142 16.9865C20.0391 17.3616 19.5304 17.5723 19 17.5723H7L3 21.5723V5.57227C3 5.04183 3.21071 4.53312 3.58579 4.15805C3.96086 3.78298 4.46957 3.57227 5 3.57227H19C19.5304 3.57227 20.0391 3.78298 20.4142 4.15805C20.7893 4.53312 21 5.04183 21 5.57227V15.5723Z"
          stroke="white"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </SvgIcon>
  );
}
